/* eslint-disable max-lines */
import '@fortawesome/fontawesome-svg-core/styles.css'; // Import the CSS
import { config, library as faLibrary } from '@fortawesome/fontawesome-svg-core'; // Tell Font Awesome to skip adding the CSS automatically since it's being imported above

/*
*************** READ THIS ***************
YOU MUST IMPORT CORRECTLY IN THIS FILE OR YOU WILL GREATLY INCREASE THE SIZE OF OUR PACKAGES
Import each icon individually from the correct package

VERY BAD:
import { faAngleDown } from '@fortawesome/pro-regular-svg-icons';

CORRECT:
import { faAngleDown } from '@fortawesome/pro-regular-svg-icons/faAngleDown';

If we do it wrong we get the WHOLE fontawesome package and there are TONS of icons and the package is HUGE
*************** READ THIS ***************
*/

// pro-regular
import { faBold } from '@fortawesome/pro-regular-svg-icons/faBold';
import { faItalic } from '@fortawesome/pro-regular-svg-icons/faItalic';
import { faCode } from '@fortawesome/pro-regular-svg-icons/faCode';
import { faH1 } from '@fortawesome/pro-regular-svg-icons/faH1';
import { faH2 } from '@fortawesome/pro-regular-svg-icons/faH2';

import { faAddressCard } from '@fortawesome/pro-regular-svg-icons/faAddressCard';
import { faArrowDownLong } from '@fortawesome/pro-regular-svg-icons/faArrowDownLong';
import { faArrowUpArrowDown } from '@fortawesome/pro-regular-svg-icons/faArrowUpArrowDown';
import { faArrowUpLong } from '@fortawesome/pro-regular-svg-icons/faArrowUpLong';
import { faArrowUpRight } from '@fortawesome/pro-regular-svg-icons/faArrowUpRight';
import { faArrowUpRightFromSquare } from '@fortawesome/pro-regular-svg-icons/faArrowUpRightFromSquare';
import { faBan } from '@fortawesome/pro-regular-svg-icons/faBan';
import { faBell } from '@fortawesome/pro-regular-svg-icons/faBell';
import { faCalendarCheck } from '@fortawesome/pro-regular-svg-icons/faCalendarCheck';
import { faBook } from '@fortawesome/pro-regular-svg-icons/faBook';
import { faBookBookmark as farBookBookmark } from '@fortawesome/pro-regular-svg-icons/faBookBookmark';
import { faBookmark } from '@fortawesome/pro-regular-svg-icons/faBookmark';

import { faBookOpen } from '@fortawesome/pro-regular-svg-icons/faBookOpen';
import { faBoxArchive as farBoxArchive } from '@fortawesome/pro-regular-svg-icons/faBoxArchive';
import { faCalendarCirclePlus } from '@fortawesome/pro-regular-svg-icons/faCalendarCirclePlus';
import { faCalendarClock } from '@fortawesome/pro-regular-svg-icons/faCalendarClock';
import { faCalendarDay as faRegularCalendarDay } from '@fortawesome/pro-regular-svg-icons/faCalendarDay';
import { faCalendarLines } from '@fortawesome/pro-regular-svg-icons/faCalendarLines';
import { faCalendarXmark } from '@fortawesome/pro-regular-svg-icons/faCalendarXmark';
import { faCalendarStar } from '@fortawesome/pro-solid-svg-icons/faCalendarStar';

import { faChartLine } from '@fortawesome/pro-regular-svg-icons/faChartLine';
import { faChartSimple } from '@fortawesome/pro-regular-svg-icons/faChartSimple';
import { faChevronRight as faRegularChevronRight } from '@fortawesome/pro-regular-svg-icons/faChevronRight';
import { faCircleArrowDown } from '@fortawesome/pro-regular-svg-icons/faCircleArrowDown';
import { faCircleInfo } from '@fortawesome/pro-regular-svg-icons/faCircleInfo';
import { faCircleStar } from '@fortawesome/pro-regular-svg-icons/faCircleStar';
import { faChalkboard as farChalkboard } from '@fortawesome/pro-regular-svg-icons/faChalkboard';
import { faClipboard } from '@fortawesome/pro-regular-svg-icons/faClipboard';
import { faClock as faRegularClock } from '@fortawesome/pro-regular-svg-icons/faClock';
import { faClockRotateLeft } from '@fortawesome/pro-regular-svg-icons/faClockRotateLeft';
import { faCopy as faCopyRegular } from '@fortawesome/pro-regular-svg-icons/faCopy';
import { faEnvelope as farEnvelope } from '@fortawesome/pro-regular-svg-icons/faEnvelope';
import { faEllipsis } from '@fortawesome/pro-regular-svg-icons/faEllipsis';
import { faFile } from '@fortawesome/pro-regular-svg-icons/faFile';
import { faFileCertificate } from '@fortawesome/pro-regular-svg-icons/faFileCertificate';
import { faFiles } from '@fortawesome/pro-regular-svg-icons/faFiles';
import { faFileSlash } from '@fortawesome/pro-regular-svg-icons/faFileSlash';
import { faFilms } from '@fortawesome/pro-regular-svg-icons/faFilms';
import { faFontCase } from '@fortawesome/pro-regular-svg-icons/faFontCase';
import { faGift } from '@fortawesome/pro-regular-svg-icons/faGift';
import { faGiftCard } from '@fortawesome/pro-regular-svg-icons/faGiftCard';
import { faGraduationCap as faRegularGraduationCap } from '@fortawesome/pro-regular-svg-icons/faGraduationCap';
import { faGripDots } from '@fortawesome/pro-regular-svg-icons/faGripDots';
import { faUser } from '@fortawesome/pro-regular-svg-icons/faUser';
import { faUserGraduate } from '@fortawesome/pro-regular-svg-icons/faUserGraduate';
import { faUserPlus as faUserPlusRegular } from '@fortawesome/pro-regular-svg-icons/faUserPlus';
import { faGripDotsVertical } from '@fortawesome/pro-regular-svg-icons/faGripDotsVertical';
import { faGripLines } from '@fortawesome/pro-regular-svg-icons/faGripLines';
import { faImage } from '@fortawesome/pro-regular-svg-icons/faImage';
import { faImages } from '@fortawesome/pro-regular-svg-icons/faImages';
import { faKey as faRegularKey } from '@fortawesome/pro-regular-svg-icons/faKey';
import { faLanguage } from '@fortawesome/pro-regular-svg-icons/faLanguage';
import { faLink } from '@fortawesome/pro-regular-svg-icons/faLink';
import { faList } from '@fortawesome/pro-regular-svg-icons/faList';
import { faLock as faLockRegular } from '@fortawesome/pro-regular-svg-icons/faLock';
import { faLockOpen } from '@fortawesome/pro-regular-svg-icons/faLockOpen';
import { faMinus } from '@fortawesome/pro-regular-svg-icons/faMinus';
import { faLockKeyholeOpen } from '@fortawesome/pro-regular-svg-icons/faLockKeyholeOpen';
import { faLockKeyhole as faRegularKeyHole } from '@fortawesome/pro-regular-svg-icons/faLockKeyhole';
import { faPaperclip } from '@fortawesome/pro-regular-svg-icons/faPaperclip';
import { faPlus } from '@fortawesome/pro-regular-svg-icons/faPlus';
import { faPlusCircle as faRegularPlusCircle } from '@fortawesome/pro-regular-svg-icons/faPlusCircle';
import { faPrint } from '@fortawesome/pro-regular-svg-icons/faPrint';
import { faRectangleList } from '@fortawesome/pro-regular-svg-icons/faRectangleList';
import { faPen as farPen } from '@fortawesome/pro-regular-svg-icons/faPen';
import { faRectangleVerticalHistory as faRegularRectangleVerticalHistory } from '@fortawesome/pro-regular-svg-icons/faRectangleVerticalHistory';
import { faRotate } from '@fortawesome/pro-regular-svg-icons/faRotate';
import { faRotateLeft } from '@fortawesome/pro-regular-svg-icons/faRotateLeft';
import { faRotateRight } from '@fortawesome/pro-regular-svg-icons/faRotateRight';
import { faSearch } from '@fortawesome/pro-regular-svg-icons/faSearch';
import { faShareNodes } from '@fortawesome/pro-regular-svg-icons/faShareNodes';
import { faShieldKeyhole } from '@fortawesome/pro-regular-svg-icons/faShieldKeyhole';
import { faSliders } from '@fortawesome/pro-regular-svg-icons/faSliders';
import { faSpinner } from '@fortawesome/pro-regular-svg-icons/faSpinner';
import { faSquare } from '@fortawesome/pro-regular-svg-icons/faSquare';
import { faStar } from '@fortawesome/pro-regular-svg-icons/faStar';
import { faTextSize } from '@fortawesome/pro-regular-svg-icons/faTextSize';
import { faTowerBroadcast } from '@fortawesome/pro-regular-svg-icons/faTowerBroadcast';
import { faTrash as faTrashRegular } from '@fortawesome/pro-regular-svg-icons/faTrash';
import { faXmark } from '@fortawesome/pro-regular-svg-icons/faXmark';
import { faUserTag } from '@fortawesome/pro-regular-svg-icons/faUserTag';

// pro-solid
import { faAsterisk } from '@fortawesome/pro-solid-svg-icons/faAsterisk';
import { faAwardSimple } from '@fortawesome/pro-solid-svg-icons/faAwardSimple';
import { faAvocado } from '@fortawesome/pro-solid-svg-icons/faAvocado';
import { faBallotCheck } from '@fortawesome/pro-solid-svg-icons/faBallotCheck';
import { faBallPile } from '@fortawesome/pro-solid-svg-icons/faBallPile';
import { faBanana } from '@fortawesome/pro-solid-svg-icons/faBanana';
import { faBellOn } from '@fortawesome/pro-solid-svg-icons/faBellOn';
import { faBellSlash } from '@fortawesome/pro-solid-svg-icons/faBellSlash';
import { faBooks } from '@fortawesome/pro-solid-svg-icons/faBooks';
import { faBookBookmark } from '@fortawesome/pro-solid-svg-icons/faBookBookmark';
import { faBookOpenCover } from '@fortawesome/pro-solid-svg-icons/faBookOpenCover';
import { faBookReader } from '@fortawesome/pro-solid-svg-icons/faBookReader';
import { faBoxArchive } from '@fortawesome/pro-solid-svg-icons/faBoxArchive';
import { faBriefcase } from '@fortawesome/pro-solid-svg-icons/faBriefcase';
import { faBuildings } from '@fortawesome/pro-solid-svg-icons/faBuildings';
import { faCalendarDay } from '@fortawesome/pro-solid-svg-icons/faCalendarDay';
import { faChartColumn } from '@fortawesome/pro-solid-svg-icons/faChartColumn';
import { faCircleCheck } from '@fortawesome/pro-solid-svg-icons/faCircleCheck';
import { faCircleChevronUp } from '@fortawesome/pro-solid-svg-icons/faCircleChevronUp';
import { faCircleDot } from '@fortawesome/pro-solid-svg-icons/faCircleDot';
import { faCircleExclamation } from '@fortawesome/pro-solid-svg-icons/faCircleExclamation';
import { faCircleDashed } from '@fortawesome/pro-solid-svg-icons/faCircleDashed';
import { faCircleHalfStroke } from '@fortawesome/pro-solid-svg-icons/faCircleHalfStroke';
import { faCircleInfo as faRegularCircleInfo } from '@fortawesome/pro-solid-svg-icons/faCircleInfo';
import { faLanguage as faSolidLangage } from '@fortawesome/pro-solid-svg-icons/faLanguage';
import { faCircleMinus } from '@fortawesome/pro-solid-svg-icons/faCircleMinus';
import { faCirclePlay } from '@fortawesome/pro-solid-svg-icons/faCirclePlay';
import { faCirclePlus } from '@fortawesome/pro-solid-svg-icons/faCirclePlus';
import { faCircleQuestion } from '@fortawesome/pro-solid-svg-icons/faCircleQuestion';
import { faCircleX } from '@fortawesome/pro-solid-svg-icons/faCircleX';
import { faCircleXmark } from '@fortawesome/pro-solid-svg-icons/faCircleXmark';
import { faClipboardCheck } from '@fortawesome/pro-solid-svg-icons/faClipboardCheck';
import { faClipboardList } from '@fortawesome/pro-solid-svg-icons/faClipboardList';
import { faClipboardListCheck } from '@fortawesome/pro-solid-svg-icons/faClipboardListCheck';
import { faCloudArrowDown } from '@fortawesome/pro-solid-svg-icons/faCloudArrowDown';
import { faCloudArrowUp } from '@fortawesome/pro-solid-svg-icons/faCloudArrowUp';
import { faCog } from '@fortawesome/pro-solid-svg-icons/faCog';
import { faDown } from '@fortawesome/pro-solid-svg-icons/faDown';
import { faDownToLine } from '@fortawesome/pro-solid-svg-icons/faDownToLine';
import { faEnvelope } from '@fortawesome/pro-solid-svg-icons/faEnvelope';
import { faExclamation } from '@fortawesome/pro-solid-svg-icons/faExclamation';
import { faExpand } from '@fortawesome/pro-solid-svg-icons/faExpand';
import { faExpandAlt } from '@fortawesome/pro-solid-svg-icons/faExpandAlt';
import { faExternalLinkAlt } from '@fortawesome/pro-regular-svg-icons/faExternalLinkAlt';
import { faExternalLinkAlt as faSolidExternalLinkAlt } from '@fortawesome/pro-solid-svg-icons/faExternalLinkAlt';
import { faEyeSlash } from '@fortawesome/pro-solid-svg-icons/faEyeSlash';
import { faFileArrowDown } from '@fortawesome/pro-solid-svg-icons/faFileArrowDown';
import { faFileChartColumn } from '@fortawesome/pro-solid-svg-icons/faFileChartColumn';
import { faFileCsv } from '@fortawesome/pro-solid-svg-icons/faFileCsv';
import { faFileLines } from '@fortawesome/pro-solid-svg-icons/faFileLines';
import { faFilePdf } from '@fortawesome/pro-solid-svg-icons/faFilePdf';
import { faFileShield } from '@fortawesome/pro-solid-svg-icons/faFileShield';
import { faFloppyDisk } from '@fortawesome/pro-solid-svg-icons/faFloppyDisk';
import { faForward } from '@fortawesome/pro-solid-svg-icons/faForward';
import { faGear } from '@fortawesome/pro-solid-svg-icons/faGear';
import { faGiftCard as faSolidGiftCard } from '@fortawesome/pro-solid-svg-icons/faGiftCard';
import { faGraduationCap } from '@fortawesome/pro-solid-svg-icons/faGraduationCap';
import { faGridHorizontal } from '@fortawesome/pro-solid-svg-icons/faGridHorizontal';
import { faGripDots as faSolidGripDots } from '@fortawesome/pro-solid-svg-icons/faGripDots';
import { faHeart } from '@fortawesome/pro-solid-svg-icons/faHeart';
import { faHouseChimney } from '@fortawesome/pro-solid-svg-icons/faHouseChimney';
import { faIdBadge } from '@fortawesome/pro-solid-svg-icons/faIdBadge';
import { faInfo } from '@fortawesome/pro-solid-svg-icons/faInfo';
import { faKey } from '@fortawesome/pro-solid-svg-icons/faKey';
import { faLocationDot } from '@fortawesome/pro-solid-svg-icons/faLocationDot';
import { faLockKeyhole } from '@fortawesome/pro-solid-svg-icons/faLockKeyhole';
import { faMango } from '@fortawesome/pro-solid-svg-icons/faMango';
import { faMask } from '@fortawesome/pro-solid-svg-icons/faMask';
import { faMegaphone } from '@fortawesome/pro-solid-svg-icons/faMegaphone';
import { faObjectsColumn } from '@fortawesome/pro-solid-svg-icons/faObjectsColumn';
import { faOctagonExclamation } from '@fortawesome/pro-solid-svg-icons/faOctagonExclamation';
import { faPaperPlaneTop } from '@fortawesome/pro-solid-svg-icons/faPaperPlaneTop';
import { faPaperPlane } from '@fortawesome/pro-solid-svg-icons/faPaperPlane';
import { faPause } from '@fortawesome/pro-solid-svg-icons/faPause';
import { faPen } from '@fortawesome/pro-solid-svg-icons/faPen';
import { faPlay } from '@fortawesome/pro-solid-svg-icons/faPlay';
import { faPlusCircle } from '@fortawesome/pro-solid-svg-icons/faPlusCircle';
import { faPlusSquare } from '@fortawesome/pro-solid-svg-icons/faPlusSquare';
import { faPowerOff } from '@fortawesome/pro-solid-svg-icons/faPowerOff';
import { faQuestionCircle } from '@fortawesome/pro-solid-svg-icons/faQuestionCircle';
import { faRectangleVerticalHistory } from '@fortawesome/pro-solid-svg-icons/faRectangleVerticalHistory';
import { faRight } from '@fortawesome/pro-solid-svg-icons/faRight';
import { faRss } from '@fortawesome/pro-solid-svg-icons/faRss';
import { faRotate as farRotate } from '@fortawesome/pro-solid-svg-icons/faRotate';
import { faRulerTriangle } from '@fortawesome/pro-solid-svg-icons/faRulerTriangle';
import { faScaleBalanced } from '@fortawesome/pro-solid-svg-icons/faScaleBalanced';
import { faScissors } from '@fortawesome/pro-solid-svg-icons/faScissors';
import { faShuffle } from '@fortawesome/pro-solid-svg-icons/faShuffle';
import { faBadgeCheck } from '@fortawesome/pro-solid-svg-icons/faBadgeCheck';
import { faChalkboardTeacher } from '@fortawesome/pro-solid-svg-icons/faChalkboardTeacher';
import { faChalkboard } from '@fortawesome/pro-solid-svg-icons/faChalkboard';
import { faScreenUsers } from '@fortawesome/pro-solid-svg-icons/faScreenUsers';
import { faSchool } from '@fortawesome/pro-solid-svg-icons/faSchool';
import { faSliders as faSolidSliders } from '@fortawesome/pro-solid-svg-icons/faSliders';
import { faUserGraduate as faSolidUserGraduate } from '@fortawesome/pro-solid-svg-icons/faUserGraduate';

//pro-duotone
import { faLoader } from '@fortawesome/pro-duotone-svg-icons/faLoader';
import { faBoxCheck } from '@fortawesome/pro-duotone-svg-icons/faBoxCheck';
import { faCircleCaretDown } from '@fortawesome/pro-duotone-svg-icons/faCircleCaretDown';
import { faShareAll } from '@fortawesome/pro-duotone-svg-icons/faShareAll';
import { faMoonStars } from '@fortawesome/pro-duotone-svg-icons/faMoonStars';
import { faSunBright } from '@fortawesome/pro-duotone-svg-icons/faSunBright';
import { faUserPlus as faUserPlusDuotone } from '@fortawesome/pro-duotone-svg-icons/faUserPlus';
import { faFileCsv as faFileCsvDuotone } from '@fortawesome/pro-duotone-svg-icons/faFileCsv';
import { faUsers as faUsersDuotone } from '@fortawesome/pro-duotone-svg-icons/faUsers';

import {
  faAngleDown,
  faAngleLeft,
  faAngleRight,
  faAngleUp,
  faArrowLeft,
  faArrowRight,
  faArrowUpRightFromSquare as faSolidArrowUpRightFromSquare,
  faArrowRightArrowLeft,
  faAward,
  faBars,
  faBox,
  faCalendarAlt,
  faCaretRight,
  faCertificate,
  faChain,
  faCheck,
  faCheckCircle,
  faChevronUp,
  faClock,
  faCopy,
  faEye,
  faGlobe,
  faHeadphones,
  faHome,
  faJedi,
  faJournalWhills,
  faLock,
  faPenToSquare,
  faRefresh,
  faSearch as faSolidSearch,
  faSort,
  faSortDown,
  faSortUp,
  faThumbsDown,
  faThumbsUp,
} from '@fortawesome/free-solid-svg-icons';
import { faShieldCheck } from '@fortawesome/pro-solid-svg-icons/faShieldCheck';
import { faSquare1 } from '@fortawesome/pro-solid-svg-icons/faSquare1';
import { faSquare2 } from '@fortawesome/pro-solid-svg-icons/faSquare2';
import { faSquare3 } from '@fortawesome/pro-solid-svg-icons/faSquare3';
import { faSquare4 } from '@fortawesome/pro-solid-svg-icons/faSquare4';
import { faSquare5 } from '@fortawesome/pro-solid-svg-icons/faSquare5';
import { faSquare6 } from '@fortawesome/pro-solid-svg-icons/faSquare6';
import { faSquareA } from '@fortawesome/pro-solid-svg-icons/faSquareA';
import { faSquareCheck } from '@fortawesome/pro-solid-svg-icons/faSquareCheck';
import { faSquareMinus } from '@fortawesome/pro-solid-svg-icons/faSquareMinus';
import { faSquareExclamation } from '@fortawesome/pro-solid-svg-icons/faSquareExclamation';
import { faSquareInfo } from '@fortawesome/pro-solid-svg-icons/faSquareInfo';
import { faSquareLeft } from '@fortawesome/pro-solid-svg-icons/faSquareLeft';
import { faSquareUp } from '@fortawesome/pro-solid-svg-icons/faSquareUp';
import { faSquareUser } from '@fortawesome/pro-solid-svg-icons/faSquareUser';
import { faStrawberry } from '@fortawesome/pro-solid-svg-icons/faStrawberry';
import { faTableRows } from '@fortawesome/pro-solid-svg-icons/faTableRows';
import { faTag } from '@fortawesome/pro-solid-svg-icons/faTag';
import { faTimer } from '@fortawesome/pro-solid-svg-icons/faTimer';
import { faTools } from '@fortawesome/pro-solid-svg-icons/faTools';
import { faTrash } from '@fortawesome/pro-solid-svg-icons/faTrash';
import { faTriangleExclamation } from '@fortawesome/pro-solid-svg-icons/faTriangleExclamation';
import { faTrophy } from '@fortawesome/pro-solid-svg-icons/faTrophy';
import { faUndo } from '@fortawesome/pro-solid-svg-icons/faUndo';
import { faUniversalAccess } from '@fortawesome/pro-solid-svg-icons/faUniversalAccess';
import { faUpFromLine } from '@fortawesome/pro-solid-svg-icons/faUpFromLine';
import { faUserCircle } from '@fortawesome/pro-solid-svg-icons/faUserCircle';
import { faUserGroup } from '@fortawesome/pro-solid-svg-icons/faUserGroup';
import { faUserGroupCrown } from '@fortawesome/pro-solid-svg-icons/faUserGroupCrown';
import { faUserPlus } from '@fortawesome/pro-solid-svg-icons/faUserPlus';
import { faUserTimes } from '@fortawesome/pro-solid-svg-icons/faUserTimes';
import { faUsers } from '@fortawesome/pro-solid-svg-icons/faUsers';
import { faVideo } from '@fortawesome/pro-solid-svg-icons/faVideo';
import { faWheelchair } from '@fortawesome/pro-solid-svg-icons/faWheelchair';
import { faWrench } from '@fortawesome/pro-solid-svg-icons/faWrench';

import { faChevronLeft } from '@fortawesome/pro-solid-svg-icons/faChevronLeft';
import { faChevronRight } from '@fortawesome/pro-solid-svg-icons/faChevronRight';
import { faChevronDown } from '@fortawesome/pro-solid-svg-icons/faChevronDown';
import { faCircle } from '@fortawesome/pro-light-svg-icons/faCircle';
import { faCircle as faSolidCircle } from '@fortawesome/pro-solid-svg-icons/faCircle';
import { faCircleSmall as faSolidCircleSmall } from '@fortawesome/pro-solid-svg-icons/faCircleSmall';
import { faCircleQuestion as faRegularCircleQuestion } from '@fortawesome/pro-regular-svg-icons/faCircleQuestion';
import { faStar as faSolidStar } from '@fortawesome/pro-solid-svg-icons/faStar';

// brands
import { faFacebook } from '@fortawesome/free-brands-svg-icons/faFacebook';
import { faGoogle } from '@fortawesome/free-brands-svg-icons/faGoogle';
import { faGithub } from '@fortawesome/free-brands-svg-icons/faGithub';
import { faInstagram } from '@fortawesome/free-brands-svg-icons/faInstagram';
import { faLinkedin } from '@fortawesome/free-brands-svg-icons/faLinkedin';
import { faTiktok } from '@fortawesome/free-brands-svg-icons/faTiktok';
import { faTwitter } from '@fortawesome/free-brands-svg-icons/faTwitter';
import { faXTwitter } from '@fortawesome/free-brands-svg-icons/faXTwitter';
import { faWindows } from '@fortawesome/free-brands-svg-icons/faWindows';
import { faYoutube } from '@fortawesome/free-brands-svg-icons/faYoutube';

// pro-thin
import { faBuildingShield } from '@fortawesome/pro-thin-svg-icons/faBuildingShield';
import { faBullseyeArrow } from '@fortawesome/pro-thin-svg-icons/faBullseyeArrow';
import { faFlagCheckered } from '@fortawesome/pro-thin-svg-icons/faFlagCheckered';
import { faMicrochip } from '@fortawesome/pro-thin-svg-icons/faMicrochip';
import { faPuzzle } from '@fortawesome/pro-thin-svg-icons/faPuzzle';
config.autoAddCss = false;

const icons = [
  faAddressCard,
  faAngleDown,
  faAngleLeft,
  faAngleRight,
  faAngleUp,
  faArrowDownLong,
  faArrowLeft,
  faArrowLeft,
  faArrowRight,
  faArrowRightArrowLeft,
  faArrowUpArrowDown,
  faArrowUpLong,
  faArrowUpRight,
  faArrowUpRightFromSquare,
  faSolidArrowUpRightFromSquare,
  faAsterisk,
  faAvocado,
  faAward,
  faAward,
  faAwardSimple,
  faBadgeCheck,
  faBallotCheck,
  faBallPile,
  faBan,
  faBanana,
  faBars,
  faBars,
  faBell,
  faBellOn,
  faBellSlash,
  faBold,
  faBookBookmark,
  faBookOpen,
  faBookOpenCover,
  faBookmark,
  farBookBookmark,
  faBookReader,
  faBook,
  faBooks,
  faBox,
  faBoxArchive,
  farBoxArchive,
  faBoxCheck,
  faBriefcase,
  faBuildings,
  faBuildingShield,
  faBullseyeArrow,
  faCalendarAlt,
  faCalendarCheck,
  faCalendarCirclePlus,
  faCalendarClock,
  faCalendarDay,
  faCalendarLines,
  faCalendarXmark,
  faCalendarStar,
  faCaretRight,
  faCertificate,
  faChain,
  faChalkboardTeacher,
  faChalkboard,
  faChartColumn,
  farChalkboard,
  faChartSimple,
  faChartLine,
  faCheck,
  faCheckCircle,
  faChevronDown,
  faChevronDown,
  faChevronLeft,
  faChevronRight,
  faChevronUp,
  faCircle,
  faCircleArrowDown,
  faCircleCaretDown,
  faCircleCheck,
  faCircleChevronUp,
  faCircleDot,
  faCircleExclamation,
  faCircleInfo,
  faCircleStar,
  faCircleHalfStroke,
  faCircleDashed,
  faCircleMinus,
  faCirclePlay,
  faCirclePlus,
  faCircleQuestion,
  faCircleX,
  faCircleXmark,
  faClipboard,
  faClipboardCheck,
  faClipboardList,
  faClipboardListCheck,
  faClock,
  faClockRotateLeft,
  faCloudArrowDown,
  faCloudArrowUp,
  faCode,
  faCog,
  faCopy,
  faCopyRegular,
  faDown,
  faDownToLine,
  faEllipsis,
  faEnvelope,
  farEnvelope,
  faExclamation,
  faExpand,
  faExpandAlt,
  faExternalLinkAlt,
  faSolidExternalLinkAlt,
  faEye,
  faEyeSlash,
  faFacebook,
  faFile,
  faFileArrowDown,
  faFileCertificate,
  faFileChartColumn,
  faFileCsv,
  faFileLines,
  faFilePdf,
  faFiles,
  faFileShield,
  faFileSlash,
  faFilms,
  faFlagCheckered,
  faFloppyDisk,
  faFontCase,
  faForward,
  faGear,
  faGift,
  faGiftCard,
  faGithub,
  faGlobe,
  faGoogle,
  faGraduationCap,
  faGridHorizontal,
  faUserGraduate,
  faSolidUserGraduate,
  faGripDots,
  faGripDotsVertical,
  faGripLines,
  faH1,
  faH2,
  faHeadphones,
  faHeart,
  faHome,
  faHouseChimney,
  faIdBadge,
  faImage,
  faImages,
  faInfo,
  faInstagram,
  faItalic,
  faJedi,
  faJournalWhills,
  faKey,
  faRegularKey,
  faLanguage,
  faSolidLangage,
  faLink,
  faLinkedin,
  faList,
  faLoader,
  faLocationDot,
  faLock,
  faLockKeyhole,
  faLockOpen,
  faLockKeyholeOpen,
  faRegularKeyHole,
  faLockRegular,
  faMango,
  faMask,
  faMegaphone,
  faMicrochip,
  faMinus,
  faMoonStars,
  faObjectsColumn,
  faOctagonExclamation,
  faRegularClock,
  faRegularGraduationCap,
  faRegularRectangleVerticalHistory,
  faPaperclip,
  faPaperPlane,
  faPaperPlaneTop,
  faPause,
  faPen,
  faPenToSquare,
  farPen,
  faPlay,
  faPlus,
  faPlusCircle,
  faPlusSquare,
  faPowerOff,
  faPrint,
  faPuzzle,
  faQuestionCircle,
  faRectangleList,
  faRectangleVerticalHistory,
  faRefresh,
  faRegularCalendarDay,
  faRegularChevronRight,
  faRegularCircleInfo,
  faRegularCircleInfo,
  faRegularCircleQuestion,
  faRegularPlusCircle,
  faRight,
  faRotate,
  farRotate,
  faRotateLeft,
  faRotateRight,
  faRss,
  faRulerTriangle,
  faScaleBalanced,
  faSchool,
  faScissors,
  faSearch,
  faScreenUsers,
  faShareNodes,
  faShareAll,
  faShieldKeyhole,
  faShieldCheck,
  faShuffle,
  faSliders,
  faSolidCircle,
  faSolidSliders,
  faSolidCircleSmall,
  faSolidGripDots,
  faSolidGiftCard,
  faSolidSearch,
  faSolidStar,
  faSort,
  faSortDown,
  faSortUp,
  faSpinner,
  faSquare,
  faSquare1,
  faSquare2,
  faSquare3,
  faSquare4,
  faSquare5,
  faSquare6,
  faSquareA,
  faSquareCheck,
  faSquareMinus,
  faSquareExclamation,
  faSquareInfo,
  faSquareLeft,
  faSquareUp,
  faSquareUser,
  faStar,
  faStrawberry,
  faSunBright,
  faTableRows,
  faTag,
  faTextSize,
  faThumbsDown,
  faThumbsUp,
  faTiktok,
  faTimer,
  faTools,
  faTowerBroadcast,
  faTrash,
  faTrashRegular,
  faTriangleExclamation,
  faTrophy,
  faTwitter,
  faUndo,
  faUniversalAccess,
  faUpFromLine,
  faUser,
  faUserCircle,
  faUserGroup,
  faUserGroupCrown,
  faUserTimes,
  faUserPlus,
  faUserPlusRegular,
  faUserPlusDuotone,
  faFileCsvDuotone,
  faUsersDuotone,
  faUserTag,
  faUsers,
  faVideo,
  faWheelchair,
  faWindows,
  faWrench,
  faXmark,
  faXTwitter,
  faYoutube,
];

faLibrary.add(...icons);
export const library = faLibrary;
